/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItMeasurementParameterBooleanDto
 */
export interface TrackItMeasurementParameterBooleanDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterBooleanDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterBooleanDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterBooleanDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterBooleanDto
     */
    index?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TrackItMeasurementParameterBooleanDto
     */
    value?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterBooleanDto
     */
    $type?: TrackItMeasurementParameterBooleanDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementParameterBooleanDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementParameterBooleanDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterBooleanDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementParameterBooleanDtoTypeEnum = typeof TrackItMeasurementParameterBooleanDtoTypeEnum[keyof typeof TrackItMeasurementParameterBooleanDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementParameterBooleanDto interface.
 */
export function instanceOfTrackItMeasurementParameterBooleanDto(value?: unknown): value is TrackItMeasurementParameterBooleanDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementParameterBooleanDtoTypeEnum)[0];
}

export function TrackItMeasurementParameterBooleanDtoFromJSON(json: any): TrackItMeasurementParameterBooleanDto {
    return TrackItMeasurementParameterBooleanDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterBooleanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterBooleanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'index': json['index'] == null ? undefined : json['index'],
        'value': json['value'] == null ? undefined : json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementParameterBooleanDtoToJSON(value?: TrackItMeasurementParameterBooleanDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'index': value['index'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

